import { Request } from '../request';
import {
    EScheduleStatusValue,
    TServerCalendarBlockerEventDetail,
    TServerCalendarAppointmentEventDetail,
    ERescheduledAction,
    TScheduleAFollowUpVisitByProvider,
} from 'types/calendar';

type AuthCalendarPermissionProp = {
    code: string;
};

type LoginProp = {
    credential: string;
};

type FetchEvent = {
    start: string;
    end: string;
};

export const login = (credential: string) =>
    Request.get<LoginProp>({
        url: '/schedule-server/authentication',
        params: { credential },
        disableToken: true,
    });

export const opsLogin = (credential: string) =>
    Request.get<LoginProp>({
        url: '/admin-server/authentication',
        params: { credential },
        disableToken: true,
    });

export const authCalendarPermission = (code: string) =>
    Request.get<AuthCalendarPermissionProp>({
        url: '/schedule-server/authorization',
        params: { code },
    });

export const calendarEventFetch = (params: FetchEvent) =>
    Request.post({
        url: '/schedule-server/list',
        params,
    });

type FetchEventV2 = {
    startAt: string; //2025-04-01 00:00:00
    endAt: string; //2025-04-30 23:59:59
    providerIds?: number[];
};
export const calendarEventFetchV2 = (params: FetchEventV2) =>
    Request.get({
        url: '/schedule-server/calendar/v2/getCalendarSimple',
        params,
    });

export type CreateEventType = {
    channelId?: string;
    colorId: string;
    description: string;
    duration?: string;
    email?: string[];
    end: string;
    location?: string;
    meetingLink?: string;
    patientName?: string;
    patientPhone?: string;
    providerId: number;
    recurrence?: string; // "null RRULE:FREQ=DAILY RRULE:FREQ=WEEKLY;BYDAY=FR RRULE:FREQ=MONTHLY;BYDAY=4FR RRULE:FREQ=MONTHLY RRULE:FREQ=YEARLY RRULE:FREQ=WEEKLY;BYDAY=FR,MO,TH,TU,WE",
    sendForm?: string;
    serviceId?: number;
    start: string;
    summary: string;
    timeZone: string; // "America/Thule America/New_York America/Chicago America/Phoenix America/Los_Angeles America/Anchorage America/Adak"
};

export const calendarCreateEvent = (params: CreateEventType) =>
    Request.post({
        url: '/schedule-server/create',
        params,
    });

export type UpdateEventType = {
    eventId: string;
    channelId?: string;
    colorId?: string;
    description: string;
    duration?: string;
    email?: string[];
    end: string;
    location?: string;
    meetingLink?: string;
    patientName?: string;
    patientPhone?: string;
    providerId?: number;
    recurrence?: string; // "null RRULE:FREQ=DAILY RRULE:FREQ=WEEKLY;BYDAY=FR RRULE:FREQ=MONTHLY;BYDAY=4FR RRULE:FREQ=MONTHLY RRULE:FREQ=YEARLY RRULE:FREQ=WEEKLY;BYDAY=FR,MO,TH,TU,WE",
    sendForm?: string;
    serviceId?: number;
    start: string;
    summary: string;
    timeZone: string; // "America/Thule America/New_York America/Chicago America/Phoenix America/Los_Angeles America/Anchorage America/Adak"
};

export const calendarUpdateEvent = (params: UpdateEventType) =>
    Request.put({
        url: `/schedule-server/update/${params.eventId}`,
        params,
    });

export type DeleteEventType = {
    eventId: string;
};

export const calendarDeleteEvent = (params: DeleteEventType) =>
    Request.delete({
        url: '/schedule-server/del',
        params,
    });

export const authCalendarPermissionV2 = (search: string) =>
    Request.get<AuthCalendarPermissionProp>({
        url: `/schedule-server/google/calendar/callback${search}`,
    });

export const calendarCreateOrUpdateAppointment = (params: TServerCalendarAppointmentEventDetail, overrideProviderId?: number) =>
    Request.post({
        url: '/schedule-server/provider/appointment/saveOrUpdate',
        params,
        overrideProviderId,
    });

export const getCalendarAppointmentEventDetail = (id: string) =>
    Request.get({
        url: `/schedule-server/provider/appointment/${id}`,
    });

export type TUpdateAppointmentStatus = {
    reqData: {
        appointmentName: string;
        clientId: number;
        startAt: string;
        endAt: string;
        duration: number;
        serviceType: import('/Users/liuxiaocong/klarity/boxpractice/src/types/common').EServiceType;
        contactType: import('/Users/liuxiaocong/klarity/boxpractice/src/types/common').EContactTypeV2;
        serviceSpecialty: string;
        externalVideoLink: string;
        location: string;
        calendarColor: string | undefined;
        scheduledBy: import('/Users/liuxiaocong/klarity/boxpractice/src/types/calendar').EScheduledBy.PROVIDER_SCHEDULED;
        appointmentStatus: EScheduleStatusValue.SCHEDULED;
        telephone: string;
    };
    reqData: {
        appointmentName: string;
        clientId: number;
        startAt: string;
        endAt: string;
        duration: number;
        serviceType: import('/Users/liuxiaocong/klarity/boxpractice/src/types/common').EServiceType;
        contactType: import('/Users/liuxiaocong/klarity/boxpractice/src/types/common').EContactTypeV2;
        serviceSpecialty: string;
        externalVideoLink: string;
        location: string;
        calendarColor: string | undefined;
        scheduledBy: import('/Users/liuxiaocong/klarity/boxpractice/src/types/calendar').EScheduledBy.PROVIDER_SCHEDULED;
        appointmentStatus: EScheduleStatusValue.SCHEDULED;
        telephone: string;
    };
    appointmentId: number;
    //SCHEDULED("scheduled"),
    //SHOWED("showed"),
    //PATIENT_NO_SHOW("patient-no-show"),
    //PATIENT_CANCELED("patient-canceled"),
    //PATIENT_LATE_CANCELED("patient-late-canceled"),
    //ßPROVIDER_CANCELED("provider-canceled")
    cancelReason?: string;
    otherReason?: string;
    cancelNotes?: string; //not use
    confirmCharge: boolean;
    manualReason?: string;

    status: EScheduleStatusValue;
    messageToPatient?: string;
    emailSignature?: string;
    rescheduledAction?: ERescheduledAction;
    startAt?: string; //'2025-06-08T00:45:00Z',
    appointment?: TServerCalendarAppointmentEventDetail;
};

export const calendarUpdateAppointmentStatus = (params: TUpdateAppointmentStatus) =>
    Request.post({
        url: '/schedule-server/provider/appointment/updateStatus',
        params,
    });

export const calendarCreateOrUpdateBlocker = (params: TServerCalendarBlockerEventDetail) =>
    Request.post({
        url: '/schedule-server/provider/calendar/blocker/saveOrUpdate',
        params,
    });

export const getCalendarBlockerEventDetail = (id: string) =>
    Request.get({
        url: `/schedule-server/provider/calendar/blocker/${id}`,
    });

export const deleteCalendarBlockerEvent = (id: string) =>
    Request.delete({
        url: `/schedule-server/provider/calendar/blocker/${id}`,
    });

export const deleteCalendarAppointmentEvent = (id: string) =>
    Request.delete({
        url: `/schedule-server/provider/appointment/${id}`,
    });

export const sendPatientPortalInvitation = (id: string) =>
    Request.post({
        url: `/schedule-server/prospect/send/invitation/message/${id}`,
    });

export type TGetProviderTimeSlotByLength = {
    startAt: string;
    endAt: string;
    length: number;
};
export const getProviderTimeSlotByLength = (param: TGetProviderTimeSlotByLength) =>
    Request.get({
        url: '/schedule-server/calendar/v2/getCalendarAvailability',
        params: param,
    });

export const getGoogleCategory = () =>
    Request.get({
        url: '/schedule-server/google/calendar/list',
    });

export const subscribeGoogleCategory = (selectedCalendarIds: string[]) =>
    Request.post({
        url: '/schedule-server/google/calendar/subscribe',
        params: {
            selectedCalendarIds,
        },
    });

export const calendarScheduleAFollowUpVisitByProvider = (params: TScheduleAFollowUpVisitByProvider) =>
    Request.post({
        url: '/schedule-server/provider/appointment/scheduleAFollowUpVisitByProvider',
        params,
    });
